import React from 'react';
import {
	ApButtonIcon,
	ApButtonMain,
	ApButtonSecondary,
	ApInput,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import { ChartOptionsCollapsible } from '../ChartOptionsCollapsible';
import {
	Wrapper,
	Divider,
	OptionsWrapper,
	SpendWrapper,
	InputWrapper,
	RangeWrapper,
} from './ChartOptions.styles';
import Slider from 'rc-slider';
import IndustryMultiSelect from './IndustryMultiSelect';
import { SPEND_OPTIONS } from 'Benchmarks/utils';

export const ChartOptions = ({
	type,
	config,
	handleSpendRangeChange,
	handleRangeLowerChange,
	handleRangeUpperChange,
	industryOptions,
	selectedIndustry,
	onChangeIndustry,
	handleClearAllIndustry,
	handleApplyFilter,
	isShowRevenue,
	setIsShowRevenue,
	handleExport,
	setIsShowSpendYearFilter,
	handleTypeChange,
}) => {
	const { spendRange, minMaxSpendRange, spendRangeUnitMin } = config;

	const isClearAllIndustry = selectedIndustry.length > 0;

	return (
		<ChartOptionsCollapsible>
			<Wrapper>
				<OptionsWrapper>
					<IndustryMultiSelect
						name="industry"
						label="Industries"
						options={industryOptions}
						selected={selectedIndustry}
						onChange={e => onChangeIndustry(e)}
					/>
					{isClearAllIndustry && (
						<ApButtonIcon
							title="Clear All Industry"
							iconName="close"
							onClick={handleClearAllIndustry}
						/>
					)}
					<Divider />
					<React.Fragment>
						<div
							style={{
								width: '172px',
								padding: '0 0 0 5px',
								color: '#878787',
								fontSize: '14px',
							}}
						>
							{`Peer Revenue Band $(M)`}
						</div>
						<SpendWrapper>
							<InputWrapper>
								<ApInput
									value={String(spendRange[0])}
									onChange={handleRangeLowerChange}
									type="number"
									title={`${spendRange[0].toLocaleString()} ${spendRangeUnitMin.toUpperCase()}`}
								/>
							</InputWrapper>
							<RangeWrapper>
								<Slider
									range
									value={spendRange}
									min={minMaxSpendRange[0]}
									max={minMaxSpendRange[1]}
									allowCross={false}
									onChange={handleSpendRangeChange}
								/>
							</RangeWrapper>
							<InputWrapper>
								<ApInput
									style={{ padding: '0' }}
									value={String(spendRange[1])}
									onChange={handleRangeUpperChange}
									type="number"
									title={`${spendRange[1].toLocaleString()} ${spendRangeUnitMin.toUpperCase()}`}
								/>
							</InputWrapper>
						</SpendWrapper>
						<Divider />
						<ApSimpleDropdown
							label='Select Option'
							options={SPEND_OPTIONS}
							selected={type}
							onChange={handleTypeChange}
						/>
						<Divider />
						<ApButtonSecondary
							iconName="filter_outlined"
							onClick={() => setIsShowSpendYearFilter(true)}
						>
							Time Range
						</ApButtonSecondary>
						<Divider />
						<ApButtonSecondary
							iconName="filter_outlined"
							onClick={() => setIsShowRevenue(!isShowRevenue)}
						>
							Input Client Revenue
						</ApButtonSecondary>
						<Divider />
						<ApButtonSecondary onClick={handleExport}>Export</ApButtonSecondary>
						<Divider />
						<ApButtonMain
							title="Apply Filter"
							iconName="filter_outlined"
							onClick={handleApplyFilter}
						>
							Apply
						</ApButtonMain>
					</React.Fragment>
				</OptionsWrapper>
			</Wrapper>
		</ChartOptionsCollapsible>
	);
};
